import { Box } from 'components/elements'
import cytoscape from 'cytoscape'
import { GalaxyImageData } from 'features/incidents/components/type'
import { useEffect, useRef } from 'react'

const MISPGalaxyImage = ({ parentRef, galaxyImageDataArray }: { parentRef: React.RefObject<HTMLDivElement>; galaxyImageDataArray: GalaxyImageData[] }) => {
  const cyRef = useRef(null)

  let graphWidth
  useEffect(() => {
    if (!parentRef.current) return
    else {
      const parentWidth = parentRef.current.offsetWidth
      // eslint-disable-next-line react-hooks/exhaustive-deps
      graphWidth = parentWidth.toString() + 'px'

      const nodes: { data: { id: string; name: string; colour: string; type: string } }[] = []
      const edges: { data: { source: string; target: string } }[] = []

      galaxyImageDataArray?.map((galaxyImageStaticDataObj, index) => {
        const orgc = galaxyImageStaticDataObj.Orgc
        const orgcNodeId = `orgc-${index}`
        //   // Add the Orgc node the center node
        nodes.push({ data: { id: orgcNodeId, name: orgc.name, colour: 'red', type: 'ellipse' } }) // Center node color blue
        // Add Tag nodes and edges btw center node &tags
        galaxyImageStaticDataObj.Tag.forEach((tagObj: { id: any; name: any; colour: any }) => {
          nodes.push({ data: { id: tagObj.id, name: tagObj.name, colour: tagObj.colour, type: 'rectangle' } })
          edges.push({ data: { source: orgcNodeId, target: tagObj.id } })
        })
      })

      const cy = cytoscape({
        container: cyRef.current,
        style: [
          {
            selector: 'node',
            style: {
              'background-color': 'data(colour)',
              'label': 'data(name)',
              'color': '#fff',
              'text-valign': 'bottom', //aligment verticaly
              'text-halign': 'left', //aligment horizontaly
              'width': 10,
              'height': 10,
              //text styling
              // 'overlay-padding': '6px',
              // 'text-outline-color': '#4a56a6',
              // 'text-outline-width': '2px',
              'font-size': '10px', // Different font size for rectangle nodes
              'text-margin-y': 4,
              // draggable false
              // 'events': 'no',
            },
          },
          {
            selector: "node[type='rectangle']",
            style: {
              shape: 'rectangle',
            },
          },

          {
            selector: 'edge',
            style: {
              'width': 1,
              'line-color': '$gray',
              'target-arrow-color': '$gray',
              'curve-style': 'bezier',
            },
          },
        ],
        elements: {
          nodes,
          edges,
        },
        layout: {
          name: 'circle',
          fit: true,
          padding: 10,
          spacingFactor: 0.6,
        },
        userZoomingEnabled: false, //zoom graph
        userPanningEnabled: false,
        boxSelectionEnabled: false, //cannot select the box
        autolock: false, //move the graph
      })

      return () => {
        cy.destroy()
      }
    }
  }, [parentRef])

  return <Box ref={cyRef} style={{ width: graphWidth, height: '500px' }} />
}

export default MISPGalaxyImage
